<template>
  <div>
    <site-header />
    <div class="">
        <div class=" px-6 py-2 md:p-6 bg-gray-100">
          <header class="mb-3">
            <p><strong>All the Best Spots</strong></p>
            <div class="my-1">
              <button 
                class="block text-left bg-gray-100 w-full p-1 text-xs text-gray"
                @click.prevent="$router.push('/create')">
                ← Create a new list
              </button>
            </div>
  
            
          </header>

          <input v-model="search" type="search" class="block w-full border border-gray bg-white p-2 mb-2" placeholder="Search cities or spots...">
  
          <div v-if="lists">
            <div v-for="list in lists" :key="list._id">
              <div v-if="shouldShow(list)" class="py-3">
                <h3><strong><a class="text-blue-400 hover:text-blue-700" :href="list.slug">{{list.name}}</a></strong></h3>
                <p class="text-gray-700 font-bold text-sm" v-if="list.description" v-text="list.description"></p>
                <p class="text-gray text-sm">
                  <span v-for="(idea, index) in list.ideas">
                    <span v-if="index !== 0">, </span>
                    <span v-if="idea && ('name' in idea)">{{idea.name}}</span> 
                  </span>
                </p>
              </div>
            </div>
          </div>
          
        </div>
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    SiteHeader,
  },
  mounted () {
    this.getLists()
  },

  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters([
      'lists'
    ])
  },
  methods: {
    ...mapActions([
      'getLists'
    ]),
    shouldShow(list) {
      if (!(list && list.name && list.ideas && list.ideas.length)) {
        return false
      } 

      if (this.search) {
        const names = (list.name + ' ' + list.description + ' ' + list.ideas.map(idea => idea ? idea.name : '').join(' ')).toLowerCase()
        if (!names.includes(this.search.toLowerCase())) {
          return false
        }
      }

      return true
    }
  }
}
</script>

<style scoped>
.main-grid {
  height:100vh;
}
.grid-right{
  display: none;
}
@media screen and (min-width: 768px) {
  .main-grid {
    display:grid;
    grid-template-columns: 1fr 1fr;
  }
  .grid-right {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// AllPage.vue?6606895e